import { memo, useCallback } from 'react';

import { SearchIcon } from '@air/design-icons';

import { SearchCommandItem } from '~/components/SearchCommand/SearchCommandItem';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';

export type SearchCommandSuggestionListItemProps = {
  isCurrentQuery?: boolean;
  onSelect: (suggestion: string) => void;
  suggestion: string;
};

export const SearchCommandSuggestionListItem = memo(
  ({ isCurrentQuery = false, suggestion, onSelect: _onSelect }: SearchCommandSuggestionListItemProps) => {
    const { ui2026 } = useTemporaryFeatureFlags();

    const onSelect = useCallback(() => _onSelect(suggestion), [suggestion, _onSelect]);

    return (
      <SearchCommandItem data-type="suggestion" onSelect={onSelect} value={suggestion}>
        <SearchIcon className="w-4 shrink-0 ads:text-icon-default text-gray-10" />

        <div className="min-w-0 grow truncate font-medium text-14">
          {ui2026 && isCurrentQuery ? `Search for "${suggestion}"` : suggestion}
        </div>
      </SearchCommandItem>
    );
  },
);

SearchCommandSuggestionListItem.displayName = 'SearchCommandSuggestionListItem';
